import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_PLUS: GlameraIconDefinition = {
  name: 'plus',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-plus-mark" d="M5 12h14M12 5v14"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-plus-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './plus.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PlusIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_PLUS;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
